export default __webpack_public_path__ + "static/refer_repeat_recycle-7dd93a8a3686736923facb73e000a042.webp";